if (!customElements.get('golzar-purchase-bar')) {
  customElements.define('golzar-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.scope = this.closest('.gh-product-design');
      if (!this.product || !this.scope) return;
      this.abort = new AbortController();
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.gh-purchase-bar__button')) return;
        const target = this.product.querySelector('variant-selects') || this.purchaseTarget();
        if (!target) return;
        target.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        target.querySelector('select, input:not([type=hidden]), button:not([disabled])')?.focus({preventScroll: true});
      }, {signal: this.abort.signal});
      this.scope.addEventListener('click', (event) => {
        const link = event.target.closest('[data-gh-tab]');
        if (!link) return;
        const tab = this.scope.querySelector(`.product-tab-link[data-target="${link.dataset.ghTab}"]`);
        if (!tab) return;
        event.preventDefault();
        tab.click();
        this.scope.querySelector('.secondPartProduct')?.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        tab.focus({preventScroll: true});
      }, {signal: this.abort.signal});
      window.addEventListener('scroll', this.refresh, {passive: true, signal: this.abort.signal});
      window.addEventListener('resize', this.refresh, {passive: true, signal: this.abort.signal});
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.product.querySelector('.product__info-container') || this.product, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'class', 'style']});
      this.update();
    }
    purchaseTarget() {
      const targets = [...this.product.querySelectorAll('#buy-buttons-block, #new-quote-button-block, #availability-container')];
      return targets.find((element) => element.getBoundingClientRect().height > 0);
    }
    update() {
      if (!this.isConnected) return;
      const info = this.product.querySelector('.product__info-container');
      const price = info?.querySelector('.price--on-sale .price-item--sale') || info?.querySelector('.price__regular .price-item--regular');
      const value = price?.getClientRects().length ? price.textContent.trim() : '';
      const amount = this.querySelector('.gh-purchase-bar__amount');
      if (amount.textContent !== value) amount.textContent = value;
      const target = this.purchaseTarget();
      if (!target) { this.hidden = true; return; }
      const buyRect = target.getBoundingClientRect();
      const imageRect = this.product.querySelector('.product__media-wrapper')?.getBoundingClientRect();
      const sectionRect = this.scope.getBoundingClientRect();
      const buyVisible = buyRect.bottom > 110 && buyRect.top < innerHeight - 95;
      const dialogOpen = !!document.querySelector('dialog[open], body.overflow-hidden .cart-drawer.active, cart-drawer.active, .product-media-modal[open]');
      this.hidden = !matchMedia('(max-width:749px)').matches || !value || buyVisible || (imageRect && imageRect.bottom > 150) || sectionRect.bottom < 100 || dialogOpen;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
